import React, { useState } from 'react';
import { toastError } from '../../../utils/toast';

// Nombre del proyecto que abre su ficha en Proyectos (para darle permisos, asignar clientes o agregarle módulos).
export default function ProjectLink({ project, agent, onOpen }) {
  const [busy, setBusy] = useState(false);
  const label = `${project?.name || 'Proyecto'} (ID ${agent.project_id})`;
  if (!onOpen) return <span className="text-fg-dim">{label}</span>;   // un empleado ve el nombre, sin enlace a Proyectos
  const open = async () => {
    setBusy(true);
    try { await onOpen(); } catch (e) { toastError(e.message); setBusy(false); }
  };
  return (
    <button type="button" onClick={open} disabled={busy} title="Abrir el proyecto en Proyectos"
      className="text-fg-dim underline decoration-fg/20 underline-offset-4 hover:text-fg hover:decoration-fg/50 rounded
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live/60 disabled:opacity-60">
      {label}<span className="sr-only"> (abrir el proyecto)</span>
    </button>
  );
}
